import React, { MouseEvent, useMemo, useState } from 'react';
import styles from './LessonSectionSidebar.module.scss';
import RightIcon from '@assets/icons/chewron_right.svg?react';
import IconMenu from '@assets/icons/menu.svg?react';
import IconTrash from '@assets/icons/trashbin.svg?react';
import {
  SllLesson,
  LessonType as TeacherLessonType,
} from '@types';
import LessonSection from './lesson-section/LessonSection';
import { notEmpty } from '@utils/helpers';
import { sortByPosition } from '@utils/helpers';

type Props = {
  lesson: SllLesson;
  refetchLesson: () => void;
};

function Lesson(props: Props) {
  const { lesson } = props;
  const [opened, setOpened] = useState(true);

  const contentClasses = useMemo(() => {
    const classes = [styles.content];

    return classes.join(' ');
  }, []);

  const cpres = useMemo(
    () => {
      const newPres = [...(lesson?.presentation || [])].filter(notEmpty);
      newPres.sort(sortByPosition);
      return newPres;
    },
    [lesson.presentation]
  );

  const handleToggle = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    const _opened = !opened;
    setOpened(_opened);
  };

  const wrapperClassName = useMemo(() => {
    const classes = [styles.wrapper];
    if (opened) {
      classes.push(styles.opened);
    }

    return classes.join(' ');
  }, [opened]);

  return (
    <div className={wrapperClassName}>
      <div onClick={handleToggle} className={styles.titleHeader}>
        <RightIcon className={styles.rightIcon}/>
        <div className={styles.title}>Lesson Presentation</div>
      </div>
      <div className={styles.menu} style={{ display: '' }}>
        <IconMenu />
      </div>
      <ul className={styles.tree}>
        <li key={'lessonTreeHeader'}>
          <section className={contentClasses}>
            <LessonSection
              lessonOpened
              lessonType={TeacherLessonType.PRESENTATION}
              lesson={lesson}
              contents={cpres}
            />
          </section>
        </li>
      </ul>
    </div>
  );
}

export default Lesson;
